const BIC_LENGTH = 11;
const BIC_FORMAT_REGEX = /^[A-Z0-9]{11}$/i;
// Only the bank code (positions 1-4) and country code (positions 5-6) are
// authoritative when matching a user's BIC against the one derived from the IBAN.
// The location code (7-8) and branch code (9-11) can legitimately differ from
// what the IBAN registry returns (e.g. IBAN-derived FIRBILITXXX vs real FIRBIL51XXX),
// so we ignore them.
const BIC_INSTITUTION_COUNTRY_LENGTH = 6;

export const isValidBICString = (value: string): boolean =>
	value.length === BIC_LENGTH && BIC_FORMAT_REGEX.test(value);

export const normalizeValidationKey = (value: string): string =>
	value.trim().toUpperCase();

export const matchesIbanBic = (userBic: string, ibanBicMask: string): boolean => {
	const institutionCountry = (bic: string): string =>
		bic.slice(0, BIC_INSTITUTION_COUNTRY_LENGTH).toUpperCase();
	return institutionCountry(userBic) === institutionCountry(ibanBicMask);
};
